/* tslint:disable */
/* eslint-disable */
/**
 * Fulfillment Router API
 * This is the YubiEnterprise Fulfillment Router Specification
 *
 * The version of the OpenAPI document: v1-oas3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface APIResponse
 */
export interface APIResponse {
    /**
     * 
     * @type {string}
     * @memberof APIResponse
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof APIResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface FulfillmentPartners
 */
export interface FulfillmentPartners {
    /**
     * 
     * @type {string}
     * @memberof FulfillmentPartners
     */
    'fulfillment_partner_id': string;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentPartners
     */
    'fulfillment_partner_name': string;
}
/**
 * 
 * @export
 * @interface FulfillmentPartnersResponse
 */
export interface FulfillmentPartnersResponse {
    /**
     * 
     * @type {number}
     * @memberof FulfillmentPartnersResponse
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentPartnersResponse
     */
    'total_count': number;
    /**
     * 
     * @type {Array<FulfillmentPartners>}
     * @memberof FulfillmentPartnersResponse
     */
    'fulfillment_partners': Array<FulfillmentPartners>;
}
/**
 * 
 * @export
 * @interface FulfillmentPartnersResponseAllOf
 */
export interface FulfillmentPartnersResponseAllOf {
    /**
     * 
     * @type {Array<FulfillmentPartners>}
     * @memberof FulfillmentPartnersResponseAllOf
     */
    'fulfillment_partners': Array<FulfillmentPartners>;
}
/**
 * 
 * @export
 * @interface FulfillmentRuleRequest
 */
export interface FulfillmentRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof FulfillmentRuleRequest
     */
    'organization_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentRuleRequest
     */
    'country_code': string;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof FulfillmentRuleRequest
     */
    'delivery_type': ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {ShipmentTypeEnum}
     * @memberof FulfillmentRuleRequest
     */
    'shipment_type': ShipmentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentRuleRequest
     */
    'rule_quantity': number;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentRuleRequest
     */
    'fulfillment_partner_id': string;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentRuleRequest
     */
    'fulfillment_partner_name': string;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentRuleRequest
     */
    'priority': number;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentRuleRequest
     */
    'notes': string;
}


/**
 * 
 * @export
 * @interface FulfillmentRuleResponse
 */
export interface FulfillmentRuleResponse {
    /**
     * 
     * @type {string}
     * @memberof FulfillmentRuleResponse
     */
    'fulfillment_rule_id': string;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentRuleResponse
     */
    'priority': number;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentRuleResponse
     */
    'organization_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentRuleResponse
     */
    'country_code': string;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof FulfillmentRuleResponse
     */
    'delivery_type': ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {ShipmentTypeEnum}
     * @memberof FulfillmentRuleResponse
     */
    'shipment_type': ShipmentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentRuleResponse
     */
    'rule_quantity': number;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentRuleResponse
     */
    'fulfillment_partner_id': string;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentRuleResponse
     */
    'fulfillment_partner_name': string;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentRuleResponse
     */
    'notes': string;
}


/**
 * 
 * @export
 * @interface FulfillmentRuleResultSet
 */
export interface FulfillmentRuleResultSet {
    /**
     * 
     * @type {number}
     * @memberof FulfillmentRuleResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentRuleResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<FulfillmentRuleResponse>}
     * @memberof FulfillmentRuleResultSet
     */
    'fulfillment_rules': Array<FulfillmentRuleResponse>;
}
/**
 * 
 * @export
 * @interface FulfillmentRuleResultSetAllOf
 */
export interface FulfillmentRuleResultSetAllOf {
    /**
     * 
     * @type {Array<FulfillmentRuleResponse>}
     * @memberof FulfillmentRuleResultSetAllOf
     */
    'fulfillment_rules': Array<FulfillmentRuleResponse>;
}
/**
 * 
 * @export
 * @interface PaginationFields
 */
export interface PaginationFields {
    /**
     * 
     * @type {number}
     * @memberof PaginationFields
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationFields
     */
    'total_count': number;
}
/**
 * 
 * @export
 * @interface PartnerTokenMetadataResponse
 */
export interface PartnerTokenMetadataResponse {
    /**
     * 
     * @type {string}
     * @memberof PartnerTokenMetadataResponse
     */
    'token_id': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerTokenMetadataResponse
     */
    'fulfillment_partner_id': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerTokenMetadataResponse
     */
    'issued_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerTokenMetadataResponse
     */
    'expires_at': string | null;
}
/**
 * 
 * @export
 * @interface PartnerTokenRequest
 */
export interface PartnerTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof PartnerTokenRequest
     */
    'fulfillment_partner_id': string;
}
/**
 * 
 * @export
 * @interface PartnerTokenResponse
 */
export interface PartnerTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof PartnerTokenResponse
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerTokenResponse
     */
    'token_id': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerTokenResponse
     */
    'fulfillment_partner_id': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerTokenResponse
     */
    'issued_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerTokenResponse
     */
    'expires_at': string | null;
}
/**
 * 
 * @export
 * @interface PartnerTokenResultSet
 */
export interface PartnerTokenResultSet {
    /**
     * 
     * @type {number}
     * @memberof PartnerTokenResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof PartnerTokenResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<PartnerTokenMetadataResponse>}
     * @memberof PartnerTokenResultSet
     */
    'partner_tokens': Array<PartnerTokenMetadataResponse>;
}
/**
 * 
 * @export
 * @interface PartnerTokenResultSetAllOf
 */
export interface PartnerTokenResultSetAllOf {
    /**
     * 
     * @type {Array<PartnerTokenMetadataResponse>}
     * @memberof PartnerTokenResultSetAllOf
     */
    'partner_tokens': Array<PartnerTokenMetadataResponse>;
}
/**
 * Type of delivery service requested, 0 for Any, 1 for normal (standard) shipping or 2 for expedited (rush) shipping. Default=0
 * @export
 * @enum {string}
 */

export enum ShipmentDeliveryTypeEnum {
    Any = 0,
    Standard = 1,
    Expedited = 2
}


/**
 * Type of shipment, \'Any\' for Any, \'Automated\' for Automated, \'Fido2PreRegistered\' for FPR.
 * @export
 * @enum {string}
 */

export enum ShipmentTypeEnum {
    Any = 'any',
    Automated = 'Automated',
    FPR = 'Fido2PreRegistered'
}



/**
 * PartnersApi - axios parameter creator
 * @export
 */
export const PartnersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets all fulfillment partners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFulfillmentPartners: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/fulfillment-partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartnersApi - functional programming interface
 * @export
 */
export const PartnersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartnersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets all fulfillment partners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFulfillmentPartners(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FulfillmentPartnersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFulfillmentPartners(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PartnersApi - factory interface
 * @export
 */
export const PartnersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartnersApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets all fulfillment partners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFulfillmentPartners(options?: any): AxiosPromise<FulfillmentPartnersResponse> {
            return localVarFp.getFulfillmentPartners(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartnersApi - object-oriented interface
 * @export
 * @class PartnersApi
 * @extends {BaseAPI}
 */
export class PartnersApi extends BaseAPI {
    /**
     * 
     * @summary Gets all fulfillment partners
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public getFulfillmentPartners(options?: AxiosRequestConfig) {
        return PartnersApiFp(this.configuration).getFulfillmentPartners(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RulesApi - axios parameter creator
 * @export
 */
export const RulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new fulfillment rule
         * @param {FulfillmentRuleRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFulfillmentRule: async (body: FulfillmentRuleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createFulfillmentRule', 'body', body)
            const localVarPath = `/v1/serviceadmin/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete fufillment rule by id
         * @param {string} fulfillmentRuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFulfillmentRuleById: async (fulfillmentRuleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fulfillmentRuleId' is not null or undefined
            assertParamExists('deleteFulfillmentRuleById', 'fulfillmentRuleId', fulfillmentRuleId)
            const localVarPath = `/v1/serviceadmin/rules/{fulfillment_rule_id}`
                .replace(`{${"fulfillment_rule_id"}}`, encodeURIComponent(String(fulfillmentRuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all fulfillment rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFulfillmentRules: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get fulfillment rule by id
         * @param {string} fulfillmentRuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFulfillmentRuleById: async (fulfillmentRuleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fulfillmentRuleId' is not null or undefined
            assertParamExists('getFulfillmentRuleById', 'fulfillmentRuleId', fulfillmentRuleId)
            const localVarPath = `/v1/serviceadmin/rules/{fulfillment_rule_id}`
                .replace(`{${"fulfillment_rule_id"}}`, encodeURIComponent(String(fulfillmentRuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update fulfillment rule by id
         * @param {string} fulfillmentRuleId 
         * @param {FulfillmentRuleRequest} [fulfillmentRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFulfillmentRuleById: async (fulfillmentRuleId: string, fulfillmentRuleRequest?: FulfillmentRuleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fulfillmentRuleId' is not null or undefined
            assertParamExists('updateFulfillmentRuleById', 'fulfillmentRuleId', fulfillmentRuleId)
            const localVarPath = `/v1/serviceadmin/rules/{fulfillment_rule_id}`
                .replace(`{${"fulfillment_rule_id"}}`, encodeURIComponent(String(fulfillmentRuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fulfillmentRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RulesApi - functional programming interface
 * @export
 */
export const RulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RulesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new fulfillment rule
         * @param {FulfillmentRuleRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFulfillmentRule(body: FulfillmentRuleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FulfillmentRuleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFulfillmentRule(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete fufillment rule by id
         * @param {string} fulfillmentRuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFulfillmentRuleById(fulfillmentRuleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFulfillmentRuleById(fulfillmentRuleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all fulfillment rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFulfillmentRules(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FulfillmentRuleResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFulfillmentRules(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get fulfillment rule by id
         * @param {string} fulfillmentRuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFulfillmentRuleById(fulfillmentRuleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FulfillmentRuleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFulfillmentRuleById(fulfillmentRuleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update fulfillment rule by id
         * @param {string} fulfillmentRuleId 
         * @param {FulfillmentRuleRequest} [fulfillmentRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFulfillmentRuleById(fulfillmentRuleId: string, fulfillmentRuleRequest?: FulfillmentRuleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FulfillmentRuleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFulfillmentRuleById(fulfillmentRuleId, fulfillmentRuleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RulesApi - factory interface
 * @export
 */
export const RulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RulesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new fulfillment rule
         * @param {FulfillmentRuleRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFulfillmentRule(body: FulfillmentRuleRequest, options?: any): AxiosPromise<FulfillmentRuleResponse> {
            return localVarFp.createFulfillmentRule(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete fufillment rule by id
         * @param {string} fulfillmentRuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFulfillmentRuleById(fulfillmentRuleId: string, options?: any): AxiosPromise<APIResponse> {
            return localVarFp.deleteFulfillmentRuleById(fulfillmentRuleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all fulfillment rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFulfillmentRules(options?: any): AxiosPromise<FulfillmentRuleResultSet> {
            return localVarFp.getAllFulfillmentRules(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get fulfillment rule by id
         * @param {string} fulfillmentRuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFulfillmentRuleById(fulfillmentRuleId: string, options?: any): AxiosPromise<FulfillmentRuleResponse> {
            return localVarFp.getFulfillmentRuleById(fulfillmentRuleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update fulfillment rule by id
         * @param {string} fulfillmentRuleId 
         * @param {FulfillmentRuleRequest} [fulfillmentRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFulfillmentRuleById(fulfillmentRuleId: string, fulfillmentRuleRequest?: FulfillmentRuleRequest, options?: any): AxiosPromise<FulfillmentRuleResponse> {
            return localVarFp.updateFulfillmentRuleById(fulfillmentRuleId, fulfillmentRuleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RulesApi - object-oriented interface
 * @export
 * @class RulesApi
 * @extends {BaseAPI}
 */
export class RulesApi extends BaseAPI {
    /**
     * 
     * @summary Create a new fulfillment rule
     * @param {FulfillmentRuleRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RulesApi
     */
    public createFulfillmentRule(body: FulfillmentRuleRequest, options?: AxiosRequestConfig) {
        return RulesApiFp(this.configuration).createFulfillmentRule(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete fufillment rule by id
     * @param {string} fulfillmentRuleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RulesApi
     */
    public deleteFulfillmentRuleById(fulfillmentRuleId: string, options?: AxiosRequestConfig) {
        return RulesApiFp(this.configuration).deleteFulfillmentRuleById(fulfillmentRuleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all fulfillment rules
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RulesApi
     */
    public getAllFulfillmentRules(options?: AxiosRequestConfig) {
        return RulesApiFp(this.configuration).getAllFulfillmentRules(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get fulfillment rule by id
     * @param {string} fulfillmentRuleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RulesApi
     */
    public getFulfillmentRuleById(fulfillmentRuleId: string, options?: AxiosRequestConfig) {
        return RulesApiFp(this.configuration).getFulfillmentRuleById(fulfillmentRuleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update fulfillment rule by id
     * @param {string} fulfillmentRuleId 
     * @param {FulfillmentRuleRequest} [fulfillmentRuleRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RulesApi
     */
    public updateFulfillmentRuleById(fulfillmentRuleId: string, fulfillmentRuleRequest?: FulfillmentRuleRequest, options?: AxiosRequestConfig) {
        return RulesApiFp(this.configuration).updateFulfillmentRuleById(fulfillmentRuleId, fulfillmentRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TokensApi - axios parameter creator
 * @export
 */
export const TokensApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new API token for a fulfillment partner
         * @param {PartnerTokenRequest} body issue api token to fulfillment partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerToken: async (body: PartnerTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createPartnerToken', 'body', body)
            const localVarPath = `/v1/serviceadmin/fulfillment-partner-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete partner token by id
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartnerTokenById: async (tokenId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenId' is not null or undefined
            assertParamExists('deletePartnerTokenById', 'tokenId', tokenId)
            const localVarPath = `/v1/serviceadmin/fulfillment-partner-tokens/{token_id}`
                .replace(`{${"token_id"}}`, encodeURIComponent(String(tokenId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all tokens issued to fulfillment partners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerTokens: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/fulfillment-partner-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokensApi - functional programming interface
 * @export
 */
export const TokensApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TokensApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new API token for a fulfillment partner
         * @param {PartnerTokenRequest} body issue api token to fulfillment partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPartnerToken(body: PartnerTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPartnerToken(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete partner token by id
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePartnerTokenById(tokenId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePartnerTokenById(tokenId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets all tokens issued to fulfillment partners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerTokens(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerTokenResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnerTokens(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TokensApi - factory interface
 * @export
 */
export const TokensApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TokensApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new API token for a fulfillment partner
         * @param {PartnerTokenRequest} body issue api token to fulfillment partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerToken(body: PartnerTokenRequest, options?: any): AxiosPromise<PartnerTokenResponse> {
            return localVarFp.createPartnerToken(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete partner token by id
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartnerTokenById(tokenId: string, options?: any): AxiosPromise<APIResponse> {
            return localVarFp.deletePartnerTokenById(tokenId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all tokens issued to fulfillment partners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerTokens(options?: any): AxiosPromise<PartnerTokenResultSet> {
            return localVarFp.getPartnerTokens(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TokensApi - object-oriented interface
 * @export
 * @class TokensApi
 * @extends {BaseAPI}
 */
export class TokensApi extends BaseAPI {
    /**
     * 
     * @summary Create a new API token for a fulfillment partner
     * @param {PartnerTokenRequest} body issue api token to fulfillment partner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensApi
     */
    public createPartnerToken(body: PartnerTokenRequest, options?: AxiosRequestConfig) {
        return TokensApiFp(this.configuration).createPartnerToken(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete partner token by id
     * @param {string} tokenId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensApi
     */
    public deletePartnerTokenById(tokenId: string, options?: AxiosRequestConfig) {
        return TokensApiFp(this.configuration).deletePartnerTokenById(tokenId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all tokens issued to fulfillment partners
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensApi
     */
    public getPartnerTokens(options?: AxiosRequestConfig) {
        return TokensApiFp(this.configuration).getPartnerTokens(options).then((request) => request(this.axios, this.basePath));
    }
}


